export default __webpack_public_path__ + "0388d9a2c0a9afbc259e6198d1fd4ebf.png";